module.exports = __webpack_public_path__ + "static/media/pink_logo.2cb2ab24.png";